import type { SelectProps, TextFieldProps } from "@mui/material"
import { KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"

import type { AutocompleteOption } from "@/types/form-fields"

export const DEFAULT_AUTOCOMPLETE_VALUE: AutocompleteOption<string> = { id: "", label: "" }

export const TEXT_AREA_MAX_CHARACTERS = 2048

export const FIELD_LABEL_FONT_CLASSES = "text-xs font-normal leading-[0.875rem]"

export const FIELD_LABEL_BASE_CLASSES = `${FIELD_LABEL_FONT_CLASSES} block text-gray-800`

export const FIELD_LABEL_CLASSES = `${FIELD_LABEL_BASE_CLASSES} mb-2`

export const FIELD_ERROR_BASE_CLASSES = `${FIELD_LABEL_FONT_CLASSES} text-red-600`

export const FIELD_ERROR_CLASSES = `${FIELD_ERROR_BASE_CLASSES} mt-2`

export const MENU_ITEM_HEIGHT = 48

export const MENU_ITEM_PADDING_TOP = 8

export const DIVIDER_HEIGHT = 1

export const MENU_MAX_HEIGHT = MENU_ITEM_HEIGHT * 4.5 + MENU_ITEM_PADDING_TOP

export const MENU_PROPS = {
  PaperProps: {
    style: {
      maxHeight: MENU_MAX_HEIGHT,
    },
  },
}

export const TEXT_FIELD_STYLING_PROPS: Partial<TextFieldProps> = {
  variant: "outlined" as const,
  fullWidth: true,
}

export const TEXT_AREA_STYLING_PROPS: Partial<TextFieldProps> = {
  variant: "outlined" as const,
  fullWidth: true,
  multiline: true,
}

export const SELECT_STYLING_PROPS: Partial<SelectProps<string>> = {
  displayEmpty: true,
  variant: "outlined" as const,
  fullWidth: true,
  IconComponent: KeyboardArrowDownOutlined,
  MenuProps: MENU_PROPS,
}
